<template>
    <div
        v-if="!moduleInfoNull"
        class="word-wrapper"
    >
        <div class="title">开发者的话</div>
        <div
            class="content"
            :class="{folded: folded}"
        >
            <div id="devper-fold-content">
                <!-- eslint-disable vue/no-v-html -->
                <!--bca-disable-next-line-->
                <div class="rich-text" v-html="parsedHyperText"></div>
            </div>
            <div
                v-if="developerWord.source"
                class="author"
            >
                {{ developerWord.source }}
            </div>
        </div>
        <div
            v-show="folded && showMoreBar"
            id="devper-fold"
            class="toggle-btn"
            @click.stop="switchFold(false)"
        >
            <div class="toggle-text">展开</div>
            <div class="toggle-icon"></div>
        </div>
        <div
            v-show="!folded && showMoreBar"
            class="toggle-btn"
            @click.stop="switchFold(true)"
        >
            <div class="toggle-text">收起</div>
            <div class="toggle-icon reverse"></div>
        </div>
    </div>
</template>

<script>
    export default {
        options: {
            addGlobalClass: true
        },

        props: {
            developerWord: {
                type: Object,
                default: () => ({})
            }
        },

        data() {
            return {
                folded: true,
                showMoreBar: false,
                modulePblog: null
            };
        },

        computed: {
            parsedHyperText() {
                const text = this.developerWord.content;
                const parsed = text
                    && text.replace(/<br/g, '<p class="swan-br" ')
                        .replace(/>[\s(\&nbsp;)]+/g, '>');
                return parsed;
            },
            moduleInfoNull() {
                return !this.developerWord || !Reflect.ownKeys(this.developerWord).length;
            }
        },

        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.initFoldWord();
                }, 100);
            });
            let content = {
                value: 'module',
                ext: {
                    id: '',
                    ext: Object.assign({moduleName: '开发者的话'}, this.$root.extData),
                    pos: ''
                }
            }
            this.$logger.display(content);
        },

        methods: {
            switchFold(isFold) {
                this.folded = isFold;
                if (isFold) {
                    setTimeout(() => {
                        const devFold = document.getElementById('devper-fold');
                        let foldTop = devFold.offsetTop + devFold.offsetParent.offsetTop;
                        let scrollTop = foldTop - Math.floor(window.innerHeight / 3);
                        window.scrollTo({
                            top: scrollTop
                        })
                    }, 50);
                } else {
                    let content = {
                        value: 'open',
                        ext: {
                            id: '',
                            ext: Object.assign({moduleName: '开发者的话'}, this.$root.extData),
                            pos: ''
                        }
                    }
                    this.$logger.click(content);
                }
            },
            initFoldWord() {
                // 动态判断文字描述内容是否超出5行，超出需要显示更多
                const limitDescHeight = 99; // 4行高度
                const rectInfo = document.getElementById('devper-fold-content').getBoundingClientRect();
                if (rectInfo && rectInfo.height) {
                    this.showMoreBar = rectInfo.height > limitDescHeight;
                } else {
                    this.showMoreBar = null;
                }
            }
        }
    };
</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;

.inline-block {
    display: inline-block;
}
.toggle-btn {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: px2rem(0);
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: px2rem(400);
    .toggle-text {
        display: inline-block;
        font-size: px2rem(48);
        color: #3388FF;
        font-weight: 400;
    }
    .toggle-icon {
        width: px2rem(54);
        height: px2rem(54);
        display: inline-block;
        margin-left: px2rem(18);
        background: url('~public/assets/imgs/ic_arraw_down_blue.png') no-repeat;
        background-size: cover;
        &.reverse {
            transform: scale(-1);
        }
    }
}

.word-wrapper {
    position: relative;
    padding-bottom: px2rem(100);
    color: #1F1F1F;
    text-align: justify;
    font-size: px2rem(48);
    .title {
        font-size: px2rem(57);
        color: #1F1F1F;
        font-weight: bold;
        margin-bottom: px2rem(54);
    }
    .content {
        margin: 0;
        padding: 0;
        .author {
            margin-top: px2rem(54);
            font-size: px2rem(48);
            color: #1F1F1F;
            text-align: right;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        &.folded {
            max-height: px2rem(370);
            overflow: hidden;
        }
    }
}
.rich-text {
    font-size: px2rem(48) !important;
    color: #1F1F1F !important;
    line-height: px2rem(75) !important;
    img, image, .common-img {
        max-width: 91.78vw !important;
        max-height: 51.7vw !important;
        padding-top: 4.35vw !important;
        padding-bottom: 4.35vw !important;
        border-radius: 2.9vw !important;
    }
    h2, p, strong, * {
        font-size: px2rem(48) !important;
        color: #1F1F1F !important;
        font-weight: normal !important;
        line-height: px2rem(75) !important;
        margin: 0;
    }
}
</style>